import type { ChladniParamsWithSize } from "@ui/lib/chladni";
import { ChladniSVG } from "./ChladniSVG";
import { ChladniHoverClient } from "./ChladniHover.client";

export function ChladniHover(props: ChladniParamsWithSize) {
  const style = {
    stroke: "white",
    strokeWidth: 0.5,
    strokeOpacity: 0.75,
  };

  return (
    <ChladniHoverClient {...style}>
      <ChladniSVG className='tw-absolute tw-inset-0 tw-size-full' {...style} params={props} />
    </ChladniHoverClient>
  );
}
